import { render, staticRenderFns } from "./sushi-boat-modal.vue?vue&type=template&id=6f21ad97&"
import script from "./sushi-boat-modal.vue?vue&type=script&lang=js&"
export * from "./sushi-boat-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports